module.exports = __webpack_public_path__ + "static/img/fastbi.ba311e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/fastbi.png
// module id = 59YL
// module chunks = 1